export function replaceLineBreaks(text: string | undefined) {
  if (!text) return '';
  const regex = /\r\n|\n/g;
  const replacedText = text.replace(regex, '<br>');
  return replacedText;
}
